import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PageHeader from '../components/common/PageHeader';
import { FaBuilding, FaChartLine, FaBriefcase, FaGlobeAmericas } from 'react-icons/fa';

const IndustriesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { label: 'Industries' }
  ];

  const industries = [
    {
      icon: <FaBuilding className="w-12 h-12 text-secondary" />,
      title: "Building & Construction",
      description: "Strategic financial planning for real estate development, construction financing, infrastructure investment, and property portfolio management.",
      image: "/assets/house-investments-elements-assortment_23-2148793805.jpg_ml0e0k.jpg",
      path: "/industries/building-construction"
    },
    {
      icon: <FaChartLine className="w-12 h-12 text-secondary" />,
      title: "Financial Services",
      description: "Specialized solutions for banks, asset managers, insurance companies, and fintech firms to optimize operations and drive growth.",
      image: "/assets/person-looking-finance-graphs_52683-116611.jpg_mhsxez.jpg",
      path: "/industries/financial-services"
    },
    {
      icon: <FaBriefcase className="w-12 h-12 text-secondary" />,
      title: "Corporate Advisory",
      description: "Strategic guidance for mergers & acquisitions, corporate restructuring, capital raising, and forming strategic partnerships.",
      image: "/assets/business-people-brainstorming-office_1048944-25233953.jpg_amz21m.jpg",
      path: "/industries/corporate-advisory"
    },
    {
      icon: <FaGlobeAmericas className="w-12 h-12 text-secondary" />,
      title: "International Markets",
      description: "Cross-border financial strategies, global investment opportunities, currency risk management, and international regulatory compliance.",
      image: "/assets/traders-discussing-digital-currency-focus-real-time-market-graph-sellable_31965-465579.jpg_swhfj0.jpg",
      path: "/industries/international-markets"
    }
  ];

  return (
    <>
      <PageHeader
        title="Industries We Serve"
        breadcrumbs={breadcrumbs}
        backgroundImage="/assets/business-colleagues-banner-concept-with-copy-space.jpg"
      />

      <section className="py-8 md:py-24 bg-background">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6">Industry Expertise</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our professionals leverage their diverse experiences to provide valuable insights and help clients navigate today's environment by realizing opportunities across multiple industries.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
            {industries.map((industry, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-custom overflow-hidden group"
              >
                <div className="h-64 overflow-hidden">
                  <img 
                    src={industry.image} 
                    alt={industry.title} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-8">
                  <div className="flex items-center mb-4">
                    <div className="bg-secondary/10 p-3 rounded-lg mr-4">
                      {industry.icon}
                    </div>
                    <h3 className="text-2xl font-heading font-semibold text-primary">{industry.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-6">{industry.description}</p>
                  <Link 
                    to={industry.path} 
                    className="btn btn-primary"
                  >
                    Learn More
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="bg-primary text-white rounded-xl p-10 shadow-lg">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="text-center mb-8"
            >
              <h3 className="text-2xl md:text-3xl font-heading font-bold mb-4">Ready to Discuss Your Industry-Specific Needs?</h3>
              <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                Our industry experts are ready to help you navigate the unique challenges and opportunities in your sector.
              </p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <Link 
                to="/contact-us" 
                className="px-8 py-3 bg-white text-primary hover:bg-gray-100 font-semibold rounded-lg transition-colors inline-block"
              >
                Contact Our Industry Specialists
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustriesPage; 